import _ from 'lodash';
import { DateTime } from 'luxon';
import { SaveDeliveryModal } from 'modules/components/layer17';
import { DailyReportItem } from 'modules/components/layer19';

import { DailyReportCardLayout } from 'modules/components/layer05';
import React, { useState } from 'react';



export type ReportDeliveryCardProps = {
  // clientReportId
  id: string;
  deliveries: {
    id: string;
    attachments: {
      id: string;
      name: string;
      url: string;
      fileSize: string;
    }[];
    createdTimestamp: DateTime;
    receivedDate: DateTime | null;
    name: string;
    description: string;
    quantity: string;
    damageDescription: string;
    issueDescription: string;
    otherDescription: string;
  }[];
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: ReportDeliveryCardProps) => {
  const [
    isVisible,
    setIsVisible
  ] = useState(false);

  return (
    <>
      {isVisible && (
        <SaveDeliveryModal.FC
          id=''
          isVisible={isVisible}
          handleClose={() => setIsVisible(() => false)}
        />
      )}
      <DailyReportCardLayout.FC
        title='Deliveries'
        subTitle='All of stuff delivered on site.'
        actionButton={{
          text: 'Add new delivery',
          onClick: () => {
            setIsVisible(() => true);
          }
        }}
      >
        {props.deliveries.map((node) => (
          <DailyReportItem.FC
            key={node.id}
            id={node.id}
            details={{
              type: 'DELIVERY',
              damages: node.damageDescription,
              deliveryImgUrls: node.attachments.map((node) => node.url),
              events: node.otherDescription,
              finishId: '',
              description: node.description,
              finishName: '',
              issues: node.issueDescription,
              name: node.name,
              quantity: _.toNumber(node.quantity)

            }}
            reportItemType='DELIVERY'
          />
        ))}
      </DailyReportCardLayout.FC>
    </>
  );
};
